import { render } from "./PopupReserva.vue?vue&type=template&id=2df1c30c&scoped=true"
import script from "./PopupReserva.vue?vue&type=script&lang=js"
export * from "./PopupReserva.vue?vue&type=script&lang=js"

import "./PopupReserva.vue?vue&type=style&index=0&id=2df1c30c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df1c30c"]])

export default __exports__